import React from 'react';
import { MorphingFluid, ShimmerText } from '../ChatArea/Indicators';
export const LoadingSpinner: React.FC<{
  text?: string;
}> = ({ text = 'Loading...' }) => {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4">
      <MorphingFluid size="h-12 w-12" />
      <ShimmerText text={text} />
    </div>
  );
};
